import { globalEvent } from '@shared/easyfy.core';
import { addCss } from '@shared/easyfy.utils';
export class SnackBar {
  constructor() {
    globalEvent({
      type: 'click',
      events: [
        {
          event: 'close-snackbar',
          callback: this.onToggleElement,
        },
      ],
    });
  }

  private onToggleElement(e: Event) {
    const element: HTMLElement = e.target as HTMLElement;
    const snackbar = element?.closest('.snackbar');
    snackbar?.remove();
  }

  static appendSnackbar = (severity?: SnackbarSeverity, message?: string, icon?: string) => {
    const snackBarMessage = message ?? 'An error has occured, try to refresh the page.';
    const snackbarSeverity = severity ?? SnackbarSeverity.error;
    const snackBarIcon = icon ?? 'icon-warning-severe';

    let element = document.createElement('div');
    addCss(element, 'snackbar');
    addCss(element, `snackbar-${SnackbarSeverity[snackbarSeverity]}`);

    let html = `<div class="snackbar-content">
        <i class="icon ${snackBarIcon} clr-white size-sm"></i>
        <div class="snackbar-message">
          ${snackBarMessage}
        </div>
      </div>
      <button class="snackbar-close-button" data-event="close-snackbar"><i class="icon icon-close-thick clr-white size-xs"></i></button>`;

    element.innerHTML = html;

    document.body.appendChild(element);

    setTimeout(() => {
      element.remove();
    }, 7000);
  };
}

export enum SnackbarSeverity {
  success,
  warning,
  error,
}
